// extracted by mini-css-extract-plugin
module.exports = {"box":"accountRestrictionsSubForm_box__2_x9F"};